// extracted by mini-css-extract-plugin
export default {"followButton":"jK-z","followCount":"kK-z","textStyle":"lK-z"};